import React from "react";
import { Monitor, Moon, SunMedium } from "lucide-react";
import { useAppearance } from "../context/AppearanceContext";

const ICONS = {
  day: SunMedium,
  night: Moon,
  system: Monitor,
};

export default function AppearanceToggle({ compact = false }) {
  const { mode, options, setMode } = useAppearance();

  return (
    <div className={`appearance-toggle${compact ? " appearance-toggle-compact" : ""}`} role="group" aria-label="Appearance">
      {options.map((option) => {
        const Icon = ICONS[option.value];
        const isActive = mode === option.value;
        return (
          <button
            key={option.value}
            type="button"
            className={`appearance-toggle__option${isActive ? " is-active" : ""}`}
            onClick={() => setMode(option.value)}
            aria-pressed={isActive}
          >
            <Icon size={compact ? 14 : 16} strokeWidth={2} />
            <span>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}
